import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Check validity and scroll on form submit
    this.element.addEventListener('submit', this.handleSubmit.bind(this))

    // For Turbo forms
    if (this.element.dataset.turbo !== 'false') {
      this.element.addEventListener('turbo:submit-start', this.handleTurboSubmit.bind(this))
    }

    // Also handle invalid events on individual fields
    const requiredFields = this.element.querySelectorAll('[required]')
    requiredFields.forEach(field => {
      field.addEventListener('invalid', this.handleInvalid.bind(this))
    })
  }

  disconnect() {
    this.element.removeEventListener('submit', this.handleSubmit.bind(this))
    this.element.removeEventListener('turbo:submit-start', this.handleTurboSubmit.bind(this))

    const requiredFields = this.element.querySelectorAll('[required]')
    requiredFields.forEach(field => {
      field.removeEventListener('invalid', this.handleInvalid.bind(this))
    })
  }

  handleSubmit(event) {
    // Check if form is valid
    if (!this.element.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()

      // Trigger HTML5 validation to show browser messages
      this.element.reportValidity()

      // Scroll to first invalid field
      this.scrollToFirstInvalidField()
      return false
    }
  }

  handleTurboSubmit(event) {
    if (!this.element.checkValidity()) {
      event.preventDefault()
      event.detail.formSubmission.stop()

      // Trigger HTML5 validation
      this.element.reportValidity()

      // Scroll to first invalid field
      this.scrollToFirstInvalidField()
    }
  }

  handleInvalid(event) {
    // Prevent the default browser popup on the first invalid field
    // We'll handle the scrolling ourselves
    event.preventDefault()

    // Only scroll if this is the first invalid field
    const invalidFields = this.element.querySelectorAll(':invalid')
    if (invalidFields[0] === event.target) {
      this.scrollToFirstInvalidField()
    }
  }

  scrollToFirstInvalidField() {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      // Find all invalid fields
      const invalidFields = this.element.querySelectorAll(':invalid')

      if (invalidFields.length > 0) {
        const firstInvalidField = invalidFields[0]

        // Find the parent container of the field (the white box)
        const container = firstInvalidField.closest('.bg-white')

        // Scroll to the container or field with some offset
        const targetElement = container || firstInvalidField
        const yOffset = -100 // Offset to account for any fixed header
        const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset

        window.scrollTo({ top: y, behavior: 'smooth' })

        // Focus on the field after scrolling
        setTimeout(() => {
          firstInvalidField.focus()

          // Add visual feedback
          firstInvalidField.classList.add('border-red-500', 'ring-2', 'ring-red-500')

          // Remove the visual feedback after a short delay
          setTimeout(() => {
            firstInvalidField.classList.remove('ring-2', 'ring-red-500')
          }, 3000)
        }, 500)
      }
    }, 100)
  }
}